import { Button } from "../../../components";
import Layout from "../../../components/atoms/Layout";
import Section from "../../../components/atoms/Section";
import useWindowSize from "../../../hooks/useWindowSize";
import { func } from "../../../utils";
import { Container } from "../Home/Home.styled";
import "./index.scss";

const times = [
  "12.00 - 13.00",
  "13.00 - 14.00",
  "14.00 - 14.40",
  "14.40 - 15.05",
  "15.05 - 15.30",
];
const events = [
  "Registrasi dan Makan Siang",
  "Press Conference Sesi 1",
  "Press Conference Sesi 2",
  "Performance dan Ceremony",
  "Closing dan Networking Session",
];
const Rsvp = () => {
  const { size } = useWindowSize();

  const isMobileView = (size?.width || 0) <= 768;

  const handleWa = (e) => () => {
    window.open(e, "_blank").focus();
  };
  const handleReservation = () => {
    window.open("https://forms.gle/jmR9817a7aiPWxpz5", "_blank").focus();
  };
  return (
    <>
      <Layout className="rsvp-scroll" scrollSnapType={"none"}>
        {/* {isMobileView ? (
          <div
            className="bg-[#1F2D3D80]  w-full h-[64px] flex items-center absolute "
            style={{
              background: isMobileView ? `transparent` : "#202a37",
              backgroundSize: "cover",
            }}
          ></div>
        ) : null} */}
        <Container backgroundColor="#DAF7FF" paddingTop={0}>
          <Section
            id={isMobileView ? "rsvp" : "rsvp-d"}
            height={isMobileView ? "auto" : "100svh"}
          >
            <div className="flex flex-col lg:flex-row min-h-[100svh] bg-gray-900 text-white">
              {/* Left section (dark background) */}
              <div
                className="lg:w-2/3 hidden lg:block relative overflow-hidden bg-[#1f2d3d] lg:sticky lg:top-0 lg:h-screen text-white"
                style={{ maxHeight: "100vh" }}
              >
                {/* BG1: fills the column, covers any gap on wide screens */}
                <img
                  src={func.getStaticImg("bg/rsvp-kv-bg.webp")}
                  aria-hidden="true"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                {/* Key visual (portrait poster, Figma node 10399:13652):
                    PRESS CONFERENCE + pemain + strip lokasi/tanggal, bg
                    transparan biar melapis rsvp-kv-bg. object-contain fits the
                    whole poster by column height, centered — side gaps show bg. */}
                <img
                  src={func.getStaticImg("bg/presscon-kv-d.webp")}
                  alt="Piala by.U 2026 Press Conference — Jakarta, Hallf Patiunus, 3 September 2026"
                  className="absolute inset-0 w-full h-full object-contain scale-75"
                />
                {/* by.U logo pinned to the corner */}
                <img
                  src={func.getStaticImg("illustration/byU-logo.svg")}
                  onClick={() =>
                    (window.location.href = "https://pialabyu.com/rsvp")
                  }
                  className="absolute left-[4vw] top-[2vh] cursor-pointer z-10"
                />
              </div>

              {/* Right section (RSVP details) — mobile KV banner on top
                  (Figma node 8463:878). */}
              <img
                src={func.getStaticImg("bg/presscon-kv-m.webp")}
                alt="Piala by.U 2026 Press Conference — Jakarta, Hallf Patiunus, 3 September 2026"
                className="w-full lg:hidden"
              />
              <div
                className="w-full lg:flex-1 p-6 lg:py-16 lg:px-14 text-white lg:overflow-y-auto custom-scrollbar"
                style={{
                  background: `url(${func.getStaticImg("bg/rsvp-bg-d.png")})`,
                  backgroundSize: "cover",
                  maxHeight: !isMobileView ? "100vh" : "none",
                }}
              >
                <h2 className="text-[20px] font-normal leading-none mb-3 lg:mt-20 mt-6">
                  U N D A N G A N
                </h2>
                <h1 className="lg:text-[40px] text-[32px] mb-4 whitespace-pre leading-tight font-bold">
                  {`Piala by.U 2026\nPress Conference`}
                </h1>
                {/* <p className="lg:mt-[24px] mt-[32px]  text-white text-[14px] tracking-[0.08px]">
                  Konfirmasi kehadiranmu dan jadilah saksi Piala by.U 2026!
                  Pialanya Anak Muda!
                </p>
                {/* <Button
                  size={"small"}
                  className={"h-[44px] w-full lg:w-[189px] mt-6"}
                  onClick={handleReservation}
                >
                  <span className={"text-[16px"}>Reservasi Disini</span>
                </Button> */}
                <div className="h-[0.5px] border-t-[0.5px] bg-[#8f9ca530] my-10" />

                {/* Place & Time Section */}
                <div className="">
                  <h3 className="text-[20px] font-semibold">Lokasi & Waktu</h3>
                  <div className="mt-2 text-white">
                    <div className="flex flex-col mb-4">
                      <span className=" text-[#8f9ca5]">Hari, Tanggal</span>
                      <span className="">Kamis, 3 September 2026</span>
                    </div>
                    <div className="flex flex-col mb-4">
                      <span className=" text-[#8f9ca5]">Waktu</span>
                      <span>12.00 WIB - Selesai</span>
                    </div>
                    <div className="flex flex-col mb-4">
                      <span className=" text-[#8f9ca5]">Lokasi</span>
                      <b className="font-bold font-white">Hallf Patiunus</b>
                      <span className="font-white">
                        Jl. Pati Unus, Kebayoran Baru, Jakarta Selatan
                      </span>
                    </div>
                  </div>
                </div>
                <div className="h-[0.5px] border-t-[0.5px] bg-[#8f9ca530] my-10" />
                {/* Dresscode Section */}
                <div className="mt-6">
                  <h3 className="text-[20px] font-semibold mb-1">Dresscode</h3>
                  <p className="text-[14px] mt-2">Casual</p>
                  {/* Staggered Grid Layout */}
                  {/* <div className="grid grid-cols-2 gap-x-[170px] gap-y-6 w-64">
                    <div className="bg-[#D9D9D9] w-[156px] h-[156px] rounded-2xl col-span-1 r"></div>
                    <div className="bg-[#D9D9D9] w-[156px] h-[200px] rounded-2xl row-span-2"></div>
                    <div className="bg-[#D9D9D9] w-[156px] h-[200px] rounded-2xl row-span-2"></div>
                    <div className="bg-[#D9D9D9] w-[156px] h-[156px] rounded-2xl col-span-[0.5] row-span-1"></div>
                  </div> */}
                </div>
                <div className="h-[0.5px] border-t-[0.5px] bg-[#8f9ca530] my-10" />
                {/* Rundown Section */}
                <div className="mt-6">
                  <h3 className="text-[20px] font-semibold mb-1">Rundown</h3>
                  <ul className="mt-2 text-gray-700 items-center pl-0">
                    {times.map((time, index) => (
                      <>
                        <li
                          key={index}
                          className="flex py-1 items-center gap-4"
                        >
                          <span className="text-[12px] text-white whitespace-pre">
                            {time}
                          </span>
                          <span className="text-[12px] text-[#8f9ca5]">
                            {"|"}
                          </span>
                          <span className="text-[14px] text-white text-right">
                            {events[index]}
                          </span>
                        </li>
                        {index < times?.length - 1 && (
                          <div className="h-[0.5px] bg-[#8f9ca530] my-3" />
                        )}
                      </>
                    ))}
                  </ul>
                </div>
                <div className="lg:hidden h-[15svh]" />
              </div>
            </div>
          </Section>
        </Container>
      </Layout>
    </>
  );
};

export default Rsvp;
